import React, { useState, useEffect } from 'react'
import AddItemForm from '../components/AddItemForm'
import ItemList from '../components/itemList'
import BoxMessage from '../components/BoxMessage'
import Bg1 from '../img/bgcasamento.jpg'
import Bg2 from '../img/wedding0003.jpg'
import Bg3 from '../img/wedding0002b.jpg'
import Bg4 from '../img/wedding0005b.jpg'
import Bg5 from '../img/bgCT.png'
import Igreja from '../img/igreja.jpg'
import Sitio from '../img/sitio.jpg'
import firebase from '../components/firebase'
import CountDown from '../components/CountDown'

const useItems = (props) => {
  const [items, setItems] = useState([])

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection('casamentokaju')
      .onSnapshot(snapshot => {
        const listItems = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        setItems(listItems)
      })
    return () => unsubscribe()
  }, [])
  return items
}

export default () => {
  const listItem = useItems()
  const shouldShow = listItem.find( elem => elem.show === true )
  let showComments = false
  if ( shouldShow && shouldShow.show) {
    showComments = true
  }

  return (
    <div className='full-height'>
      <section className='section section-fullHeight section-one' style={{backgroundImage: `url(${Bg1})`}}>
        <div className='content-title'>
          <h1>Pedro ♥ Bianca</h1>
        </div>
      </section>

      <section className='section section-six section-padding' style={{backgroundImage: `url(${Bg5})`}}>
        <h2>Informações</h2>
        <CountDown />
      </section>

      <section className='section section-two section-padding' style={{backgroundImage: `url(${Bg2})`}}>
        <h2>Participe com a gente!</h2>
        <div className='leftContent'>
          <h5>Qual ou quais músicas não podem faltar na nossa festa? <br /> Aproveite e deixe-nos uma mensagem!</h5>
          <AddItemForm />
        </div>
        <div className='rightContent'>
          <h5>Algumas musicas escolhidas por enquanto.</h5>
          <ItemList property='userView' completeList={listItem}/>
        </div>
      </section>

      <section className='section section-three section-padding'>
        <h2>Nossas listas</h2>

        <div className='container'>
          <a href='https://americanas.com.br' target='_blank' className='box' rel='noreferrer noopener' >
            <img src='https://static.wixstatic.com/media/ae965b_3a8950e21c824aaa86ea8f14d2741c88~mv2.jpg/v1/fit/w_709,h_650,al_c,q_80/file.png' alt='logo americanas' />
          </a>
          <a href='https://www.icasei.com.br/lista-de-casamento' rel='noreferrer noopener' target='_blank' className='box'>
            <img src='https://www.icasei.com.br/facelogo.png' alt='logo icasei'/>
          </a>
          <a href='https://www.camicado.com.br/lista/home?gclid=CjwKCAjwi_b3BRAGEiwAemPNU82MVNoHNIMQ3Q57twso1nS9ZZETVEujFQJjQrAdwyPvhItqOeaTVBoCXfQQAvD_BwE' target='_blank' rel='noreferrer noopener' className='box'>
            <img src='https://2.bp.blogspot.com/-UNM8Cjyp19I/Wq-_JIGTFlI/AAAAAAAAASI/u1x4T81sF90Af5OONAHnaZNouZBSkvMJwCPcBGAYYCw/w1200-h630-p-k-no-nu/camicado.png' alt='takamine' />
          </a>
        </div>
      </section>
      {showComments && (
        <section className='section section-four section-padding format-style' style={{backgroundImage: `url(${Bg4})`}}>
          <h2>Mensagens dos convidados</h2>
          <BoxMessage completeList={listItem}/>
        </section>
      )}

      <section className='section section-five section-padding' style={{backgroundImage: `url(${Bg3})`}}>
        <div className='left-side'>
          <h2>Paróquia Nossa Senhora do Brasil</h2>
          <p>Praça Nossa Sra. do Brasil, 01 - Jardim America, São Paulo - SP, 05402-000</p>
          <div className='imagem' style={{backgroundImage: `url(${Igreja})`}} />
          <iframe title='Mapa para paróquia' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d914.2424872254867!2d-46.672710687955785!3d-23.5695227520052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe2f8d3bf0f569d98!2sIgreja%20Nossa%20Senhora%20do%20Brasil!5e0!3m2!1spt-BR!2sbr!4v1622387402798!5m2!1spt-BR!2sbr" allowfullscreen="" loading="lazy"></iframe>
        </div>
        <div className='right-side'>
          <h2>Sítio São Jorge</h2>
          <p>R. das Araribás, 25 - Bairro dos Casa, São Bernardo do Campo - SP, 09840-210</p>
          <div className='imagem' style={{backgroundImage: `url(${Sitio})`}} />
          <iframe title='Mapa para o Sítio' src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7304.219651966629!2d-46.5745723!3d-23.7434627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce413d88145c17%3A0x5856713a1bc092ef!2zU8OtdGlvIFPDo28gSm9yZ2U!5e0!3m2!1spt-BR!2sbr!4v1593724354504!5m2!1spt-BR!2sbr' frameBorder='0' allowFullScreen='' aria-hidden='false'></iframe>
        </div>
      </section>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/home.js